import index from "./niitlel.vue";
export default index;
